// :cow: Cosmose CONFIDENTIAL :iso:
import * as CampaignActions from './campaign.actions';
import { CampaignState, initialState } from './campaign.state';


export function reducer(
  state = initialState,
  action: CampaignActions.All,
): CampaignState {
  switch (action.type) {
    case CampaignActions.CLEAR_CAMPAIGN: {
      return {
        ...state,
        estimates: undefined,
        campaign: undefined,
      };
    }
    case CampaignActions.SET_CAMPAIGN_SUCCESS: {
      return {
        ...state,
        campaign: {...state.campaign, ...action.response},
      };
    }
    default: {
      return {...state};
    }
  }
}
